<script lang="ts">
  import { cn } from '@/lib/utils';
  import type { WorkoutPlayerType } from '@/Util/api';

  // TODO (hyde): use actual workout player icons instead of emojis
  export let type: WorkoutPlayerType;
  const map: Record<WorkoutPlayerType, string> = {
    garmin_connect: '/assets/global/img/providers/garmin.svg',
    zwift: '/assets/global/img/providers/zwift.svg',
    xert_ebc: '/assets/frontend/layout/img/logos/Xert Grey Icon V1.svg',
    wahoo: '/assets/images/providers/wahoo_full.svg',
    mywhoosh: '/assets/global/img/providers/com.whoosh.whooshgame.png',
    rouvy: '/assets/global/img/providers/rouvy-symbol-rgb.svg',
    garmin_workout_player: '/assets/frontend/layout/img/logos/Xert Grey Icon V1.svg',
    rungap: '/assets/frontend/layout/img/logos/Xert Grey Icon V1.svg',
    ictrainer: '/assets/frontend/layout/img/logos/Xert Grey Icon V1.svg',
  };
</script>

<img src={map[type]} alt={type} class={cn("inline-flex h-8 w-8 items-center justify-center rounded text-base", ['garmin_connect', 'zwift', 'xert_ebc', 'garmin_workout_player', 'rungap', 'ictrainer'].includes(type) ? 'p-1 bg-gray-200' : '', type == 'wahoo' ? 'bg-gray-200' : '')} />
